import React from 'react';
// import { HelpIcon } from '../../icons/HelpIcon';
import { Flex, Top } from '../../components/Flex';
import { Label } from '../../components/Text';
import { UserMenuContainer } from '../user/UserMenuContainer';

const TopPanel = () => (
    <Top>
        <Label size="18px" color="var(--sp-text-grey-color)" bold>admin panel</Label>
        <Flex gap={{ right: 16 }}>
            {/* <HelpIcon /> */}
            <UserMenuContainer />
        </Flex>
    </Top>
);

export { TopPanel };